import './Skeleton.css'

export type SkeletonProps = {
  /** Number of placeholder lines. Defaults to 3. */
  lines?: number
  /** Height of each line in px. Defaults to 16. */
  height?: number
}

/** Shimmering loading placeholder; announced once via role="status". */
export function Skeleton({ lines = 3, height = 16 }: SkeletonProps) {
  const count = Math.max(1, Math.round(lines))
  return (
    <div className="ui-skeleton" role="status" aria-label="Inhoud wordt geladen">
      {Array.from({ length: count }, (_, index) => (
        <span
          key={index}
          className="ui-skeleton__line"
          aria-hidden="true"
          style={{
            height,
            width: index === count - 1 && count > 1 ? '60%' : '100%',
          }}
        />
      ))}
    </div>
  )
}
